import { useQuery } from '@tanstack/react-query'
import { getAssignableBuyers, type AssignableUser } from '../../../shared/api/users.api'
import { useAuthStore } from '../../auth/authStore'

/**
 * Роли, у которых в карточке заявки есть назначение позиций («Назначен»,
 * «Назначить…»). РОЗ — с 29.09.2026 (№50): назначает себя и свою команду.
 */
const ASSIGNER_ROLES = new Set(['ADMIN', 'MANAGER', 'ROP', 'ASSISTANT', 'ROS'])

export function canAssignItems(role: string | undefined): boolean {
  return !!role && ASSIGNER_ROLES.has(role)
}

/** Подпись в выпадашке: «Имя» у закупщика, «Имя (РОЗ)» у руководителя закупок. */
export function assigneeLabel(u: { name?: string | null; email: string; role?: string }): string {
  const base = u.name || u.email
  return u.role === 'ROS' ? `${base} (РОЗ)` : base
}

const EMPTY: AssignableUser[] = []

/**
 * Кого можно назначить (GET /users/assignable-buyers): закупщики и РОЗ, для
 * РОЗ — она сама и её команда. Ключ с id пользователя — у РОЗ свой список.
 */
export function useAssignableBuyers(): AssignableUser[] {
  const user = useAuthStore((s) => s.user)
  const { data } = useQuery({
    queryKey: ['assignable-buyers', user?.id],
    queryFn: getAssignableBuyers,
    enabled: canAssignItems(user?.role),
    staleTime: 60_000,
  })
  return data ?? EMPTY
}
